import { map, tap } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import {
    AppConfig,
    ConfigEnvironments
} from '../../../../common/models/app-config.interface';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS } from '../../app-settings';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { AuthErrorCode } from '../../../../common/models/auth-api.interface';

/**
 *  This service is initialized before the application bootstrap with okta config data from the server
 *  and checks the current user authentication status.
 *  It also provided okta config data properties.
 */
@Injectable()
export class ConfigManagerService {
    private appConfig: AppConfig = null;

    constructor(
        protected http: HttpClient,
        @Inject(APP_SETTINGS) protected appSettings
    ) {}

    /**
     * init is used in APP_INITIALIZER, hence it needs to return a promise
     */
    init(): Promise<ConfigManagerService> {
        return this.getConfigs()
            .pipe(
                map((response: ApiResponse<AppConfig[]>) => {
                    this.appConfig = response.data[0];
                    return this;
                })
            )
            .toPromise();
    }

    private getConfigs(): Observable<ApiResponse<AppConfig[]>> {
        return this.http.get<ApiResponse<AppConfig[]>>(
            this.appSettings.apiEndpoint + 'configs'
        );
    }

    get logoutUrl() {
        return this.appConfig.sso.logout;
    }

    get ssoUrl() {
        return `${this.appConfig.sso.home}`;
    }

    get profileUrl() {
        return `${this.appConfig.sso.home}/profile`;
    }

    doAuthenticationRedirect(authErrorCode: AuthErrorCode) {
        window.location.href = `${
            this.appConfig.sso.home
        }/error?code=${authErrorCode.toString()}&application=merchandising&returnUrl=${
            this.appConfig.core.home
        }`;
    }

    get apps() {
        return this.appConfig.apps;
    }

    get ssoConfig() {
        return this.appConfig.sso;
    }

    get version() {
        return this.appConfig.version;
    }

    get environment(): ConfigEnvironments {
        return this.appConfig.environment;
    }

    get retailerDashboardUrl() {
        return this.appConfig.core.retailerDashboard;
    }
}
